const API_URL = process.env.VUE_APP_API_URL+'/nc'

//import { router } from '../main.js'
import { userService } from './userServices.js';

export const stampeService = {
    
    printAc,printAllAc,printCivico

};

function printCivico(prgNe, mapImg){
    const sid = userService.getSessionId()
    const comune = userService.getCurrentComune()
    const formData  = new FormData();

  
    formData.append("sid", sid);
    formData.append("comune", comune);
    formData.append("prgNe", prgNe);
    formData.append("mapImg", mapImg);
    const requestOptions= {
        method: 'POST',
        body: formData
      };

      
    return fetch(API_URL + '/print/getCivicoPdf', requestOptions).then(userService.handleResponse)
        .then(ret => {
            

            if (ret) {

                return ret;
            }

            return 'errore';
        });
}
function printAc(prgAc){
    const sid = userService.getSessionId()
    const comune = userService.getCurrentComune()
    const allAc='0';


    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, allAc, prgAc })
    };


    return fetch(API_URL + '/print/getAcPdf', requestOptions).then(userService.handleResponse)
        .then(ret => {
            

            if (ret) {

                return ret;
            }

            return 'errore';
        });
} 
function printAllAc(){
    const sid = userService.getSessionId()
    const comune = userService.getCurrentComune()
    const allAc='1';
    const prgAc=[];

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': '1111' },
        mode: "cors",
        cache: "default",
        body: JSON.stringify({ sid, comune, allAc, prgAc })
    };


    return fetch(API_URL + '/print/getAcPdf', requestOptions).then(userService.handleResponse)
        .then(ret => {
            

            if (ret) {

                return ret;
            }

            return 'errore';
        });
}